
        import 'Toggle.214c380.css-module'
        export default {"Toggle":"Toggle_Toggle_214c380"}
    